export default __webpack_public_path__ + "static/media/channel2.600fe630.svg";